<template>
  <div class="bg">
    <div class="home-container">
      <div class="flex justify-around flex-col lg:flex-row">
        <div class="px-12 py-12 pb-6 lg:py-20 lg:w-1/2">
          <div class="text-xl font-title tracking-tighter">
            Why did our inventor made this? 💎
          </div>
          <div class="">
            Lok Lok dreamed about making the Web more and more Fancy and 3D. So he decided to build different tools to democratise digital visual effect. 😎
          </div>
        </div>
        <div class="px-12 py-12 pt-6 lg:py-20 lg:w-1/2">
          <div class="text-xl font-title tracking-tighter">
            Remembering what I dreamed about. ❤️
          </div>
          <div class="">
            Being truthful to myself has helped me a lot in life and career. By taking action and practicing coding, I'm keeping my dream self alive. It's my way of realising my vision. 🤲🏻
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped lang="postcss">
.bg{
  background-color: #F4F5F7;
}
</style>
